import React from 'react';
import { Layout } from '../components/sections/Layout';
import { FeatureRegistration } from '../components/sections/FeatureRegistration';
import { FeatureNetworking } from '../components/sections/FeatureNetworking';
import { FinalCTA } from '../components/sections/FinalCTA';
export function AvantPage() {
  return <Layout data-id="element-781">
      <FeatureRegistration data-id="element-782" />
      <FeatureNetworking data-id="element-783" />
      <FinalCTA data-id="element-784" />
    </Layout>;
}